export const showChangePassword = (state, flag) => {
	state.showChangePassword = flag
}